// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/dress-report/styles.scss
// module id = 996
// module chunks = 0